export type SupervisiAmbulansHasil = "ya" | "tidak" | "na" | null;

export type SupervisiAmbulansKategori =
  | "fasilitas-apd"
  | "kebersihan-ambulan"
  | "kepatuhan-petugas";

export interface SupervisiAmbulansItem {
  id: number;
  kategori: SupervisiAmbulansKategori;
  item_key: string;
  item_label: string;
  urutan: number;
  hasil: SupervisiAmbulansHasil;
  masalah: string | null;
  rekomendasi: string | null;
}

export interface AmbulansRef {
  id: number;
  kode: string;
  nama: string | null;
  plat_nomor: string | null;
  tipe: string;
  status: string;
}

export interface UserRef {
  id: number;
  nama: string | null;
}

export interface SupervisiAmbulans {
  id: number;
  nomor_formulir: string | null;
  ambulans_id: number | null;
  ambulans: AmbulansRef | null;
  tanggal_supervisi: string;
  waktu_mulai: string | null;
  waktu_selesai: string | null;

  supervisor_user_id: number;
  supervisor: UserRef | null;
  supervisor_jabatan: string | null;
  signed_supervisor: boolean;
  signed_supervisor_at: string | null;

  kepala_unit_user_id: number | null;
  kepala_unit: UserRef | null;
  kepala_unit_nama_manual: string | null;
  signed_kepala_unit: boolean;
  signed_kepala_unit_at: string | null;

  temuan_utama: string | null;
  rencana_tindak_lanjut: string | null;

  is_locked: boolean;
  items?: SupervisiAmbulansItem[];

  created_at: string;
  updated_at: string;
}

export const KATEGORI_LABEL: Record<SupervisiAmbulansKategori, string> = {
  "fasilitas-apd": "I.  Supervisi Fasilitas Kebersihan Tangan dan APD",
  "kebersihan-ambulan": "II. Supervisi Kebersihan Ambulan",
  "kepatuhan-petugas": "III. Supervisi Kepatuhan Petugas",
};
